import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-16 scroll-mt-20" style={{ backgroundColor: 'oklch(var(--background-50))' }}>
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">焦点推荐</h2>
          <p className="text-sm text-foreground-500 mt-2">编辑精选 · 人气爆款 · 不容错过</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselData.map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden cursor-pointer transition-all duration-300 border"
              style={{
                backgroundColor: 'oklch(var(--background-50))',
                borderColor: 'oklch(var(--background-200))',
              }}
            >
              <div className="relative overflow-hidden aspect-[16/10]">
                <img
                  src={item.image}
                  alt={`${item.title} — ${item.subtitle}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium" style={{ backgroundColor: 'oklch(var(--primary-500))', color: 'oklch(var(--background-50))' }}>
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <p className="text-xs text-white/80 mb-1">{item.subtitle}</p>
                  <h3 className="text-lg font-heading font-bold text-white">{item.title}</h3>
                </div>
              </div>
              <div className="p-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}